import React, { useState } from "react";
import {
  createTheme,
  ThemeProvider,
  CssBaseline,
  Paper,
  Typography,
  TextField,
  Grid,
  Container,
  Button
} from "@mui/material";
import HeaderIcon from "../../Images/headericon.png";
import { useParams } from "react-router-dom";
import { AddibkrAssets } from "../../redux/Actions/transactionsService";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";

const theme = createTheme();

const Index = () => {
  const { id } = useParams();
  const [assetName, setAssetName] = useState("");
  const [assetSymbol, setAssetSymbol] = useState("");
  const [assets, setAssets] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const dispatch = useDispatch();

  const handleAddAsset = () => {
    if (assetName && assetSymbol) {
      if (editIndex !== null) {
        // Editing an existing asset
        const updatedAssets = assets.map((asset, index) =>
          index === editIndex ? { name: assetName, symbol: assetSymbol } : asset
        );
        setAssets(updatedAssets);
        setEditIndex(null);
      } else {
        // Adding a new asset
        setAssets([...assets, { name: assetName, symbol: assetSymbol }]);
      }
      setAssetName("");
      setAssetSymbol("");
    }
  };

  const handleEditAsset = (index) => {
    const asset = assets[index];
    setAssetName(asset.name);
    setAssetSymbol(asset.symbol);
    setEditIndex(index);
  };

  const handleDeleteAsset = (index) => {
    const updatedAssets = assets.filter((_, i) => i !== index);
    setAssets(updatedAssets);
  };

  const handleSubmitAssets = async () => {
    const payload = {
      assets: assets.map(asset => ({ name: asset.name, symbol: asset.symbol })),
    };
    try {
      const result = await dispatch(AddibkrAssets({ payload, id }));
      if (result.payload.statusCode === 201) {
        Swal.fire("Success", "Assets added successfully!", "success");
        setAssets([]); // Clear the asset list
      } else {
        Swal.fire("Error", "Failed to add assets.", "error");
      }
    } catch (error) {
      console.error("Error submitting assets:", error);
      Swal.fire("Error", "An error occurred while adding assets.", "error");
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Paper
        sx={{ p: 2, display: "flex", flexDirection: "column" }}
        elevation={0}
      >
        <div className="row rows" style={{ marginLeft: "2px" }}>
          <div className="col-1">
            <img src={HeaderIcon} alt="Header Icon" width="45" height="45" />
          </div>
          <div className="col-9" style={{ marginTop: "10px" }}>
            <Typography variant="h6" style={{ color: "#18275A" }}>
              Add Crypto Assets for {id.toUpperCase()}
            </Typography>
          </div>
        </div>
      </Paper>

      <Container
        maxWidth="lg"
        component="main"
        sx={{ mt: 5, ml: -2, pl: 0 }}
      >
        <Typography variant="h5" sx={{ mb: 2 }}>
          {editIndex !== null ? "Edit Asset" : "Add Asset"}
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              label="Asset Name"
              variant="outlined"
              fullWidth
              value={assetName}
              onChange={(e) => setAssetName(e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Asset Symbol"
              variant="outlined"
              fullWidth
              value={assetSymbol}
              onChange={(e) => setAssetSymbol(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              sx={{
                mt: 2,
                backgroundColor: "#1ba0f4",
                color: "#FFFFFF",
                "&:hover": {
                  backgroundColor: "#1565C0",
                },
              }}
              onClick={handleAddAsset}
            >
              {editIndex !== null ? "Update Asset" : "Add Asset"}
            </Button>
          </Grid>
        </Grid>
        <Typography variant="h6" sx={{ mt: 4 }}>
          Asset List
        </Typography>
        {assets.length === 0 ? (
          <Typography variant="body1" sx={{ textAlign: "center", mt: 2 }}>
            No assets added yet.
          </Typography>
        ) : (
          <Grid container spacing={2} sx={{ mt: 2 }}>
            {assets.map((asset, index) => (
              <Grid item xs={12} key={index}>
                <Paper sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography variant="body1">
                    <b>Name:</b> {asset.name} {"        "} <b>Symbol:</b> {asset.symbol}
                  </Typography>
                  <div>
                    <Button
                      variant="outlined"
                      sx={{ mr: 1 }}
                      onClick={() => handleEditAsset(index)}
                    >
                      Edit
                    </Button>
                    <Button
                      variant="outlined"
                      color="error"
                      onClick={() => handleDeleteAsset(index)}
                    >
                      Delete
                    </Button>
                  </div>
                </Paper>
              </Grid>
            ))}
          </Grid>
        )}
        {assets.length > 0 && (
          <Grid item xs={12}>
            <Button
              variant="contained"
              sx={{
                mt: 2,
                backgroundColor: "#1ba0f4",
                color: "#FFFFFF",
                "&:hover": {
                  backgroundColor: "#1565C0",
                },
              }}
              onClick={handleSubmitAssets}
            >
              Submit
            </Button>
          </Grid>
        )}
      </Container>
    </ThemeProvider>
  );
};

export default Index;
